import { FlowFrame } from "../../components/PageShell";
import { useTranslation } from "../../i18n/useTranslation";
import { OutcomeTitle } from "./outcomeTitle";
import { SUPPORT_HREF } from "../../lib/support";

/**
 * THE SERVER ANSWERED AND WE CANNOT DESCRIBE THE ANSWER: a deposit journey
 * this cohort does not have, facts that contradict each other, or an
 * appointment that is not the one the client selected. The signed-in path
 * (Book.tsx) and the guest checkout (guest/GuestReviewRoute.tsx) both land
 * here.
 *
 * Deliberately NOT folded into `failed`: that copy says "nothing has
 * changed", and here something may well have; a booking may exist. The one
 * thing this screen must not do is invite a second attempt, so it has no
 * booking action and no Back. It does offer "Get help" (rc.13, the Founder's
 * dead-end finding): support is the way forward when a booking may exist,
 * and it invites no second attempt. The plain mailto: nothing about this
 * answer is put into the email.
 *
 * A flow frame (c6-2), so the flow's one header (wordmark, Appearance) stays
 * the same node into it; before c6-2 it drew a bare <main> with no header.
 * Its heading is the alert's title line (an <h1> since C62-N1, unchanged on
 * screen), so the page has exactly one.
 */
export function BookingUnauthorized({ business }: { business: string }) {
  const { t } = useTranslation();
  return (
    <FlowFrame testId="booking-unauthorized" lead={null}>
      <OutcomeTitle business={business} />
      <div className="b-scroll">
        <div className="b-notice t-danger" role="alert">
          <div className="b-notice-b">
            {/* The screen's one heading (QE C62-N1): the alert's existing title
                line, styled exactly as the bold line it was (.b-notice-title). */}
            <h1 className="b-notice-title">{t("flow.outcome.unauthorized.title")}</h1>
            <p className="b-p">{t("flow.outcome.unauthorized.body", { business })}</p>
          </div>
        </div>
      </div>
      <div className="b-foot">
        <a className="b-btn v-secondary is-full" href={SUPPORT_HREF} data-testid="booking-unauthorized-help">
          {t("guest.help")}
        </a>
      </div>
    </FlowFrame>
  );
}
